import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
    toast: {
        zIndex: 99999
    }
}));
